import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { hideDialog } from '../../../store/dialog/dialog.actions';
import AlertPopup from '@aib/uikit-react/dist/Content/AlertPopup/AlertPopup';
import {
  confirmLogoutClickAction,
  refreshSessionAction,
  autoLogoutAction,
} from '../../../store/session';
import Utils from '../../../lib/utils';
import dialogConfigFactory from './dialogConfigFactory';

interface Props {
  logout: (...args: unknown[]) => unknown;
  stayLoggedIn: (...args: unknown[]) => unknown;
  onAutoLogout: (...args: unknown[]) => unknown;
}

function AutoLogoutDialog({ logout, stayLoggedIn, onAutoLogout }: Props) {
  const [warningTime, setWarningTime] = useState(
    Utils.getSetting('AUTO_LOGOUT_WARNING_TIME')
  );

  useEffect(() => {
    if (warningTime > 0) {
      setTimeout(() => setWarningTime(warningTime - 1), 1000);
    } else {
      onAutoLogout();
    }
  });

  const dialogConfig = dialogConfigFactory({
    heading: 'Automatic Logout',
    content: `You will be logged out of MyMortgage in ${warningTime.toString()} seconds due to inactivity.`,
    visible: true,
    cancel: 'Log out',
    accept: 'Stay logged in',
  });

  return (
    <AlertPopup
      id="AutoLogoutDialog"
      title={dialogConfig.heading}
      confirmLabel={dialogConfig.accept}
      cancelLabel={dialogConfig.cancel}
      isOpen={true}
      onConfirm={stayLoggedIn}
      onIconButtonClose={stayLoggedIn}
      onCancel={logout}
      buttonFlex={true}
    >
      {dialogConfig.content}
    </AlertPopup>
  );
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  logout: () => {
    dispatch(hideDialog());
    dispatch(confirmLogoutClickAction());
  },
  stayLoggedIn: () => {
    ownProps.onRefresh();
    dispatch(hideDialog());
    dispatch(refreshSessionAction());
  },
  onAutoLogout: () => {
    dispatch(autoLogoutAction());
  },
});

export default connect(null, mapDispatchToProps)(AutoLogoutDialog);
